import browser from "webextension-polyfill";
function getMV2ScriptToInject(injectedFunction, ...params) {
    const args = JSON.stringify([...params]);
    const stringified = JSON.stringify(injectedFunction.toString());
    const wrapped = `"(${stringified.slice(1, -1)}).apply(null,${JSON.stringify(args).slice(1, -1)});"`;
    return `
    function injectScriptInMainContext(executable) {
      let script = document.createElement("script");
      script.type = "application/javascript";
      script.async = false;

      // Firefox 58 only bypasses site CSPs when assigning to 'src',
      // while Chrome 67 and Microsoft Edge (tested on 44.17763.1.0)
      // only bypass site CSPs when using 'textContent'.
      if (typeof netscape != "undefined" && typeof browser != "undefined") {
        let url = URL.createObjectURL(new Blob([executable]));
        script.src = url;
        document.documentElement.appendChild(script);
        URL.revokeObjectURL(url);
      } else {
        script.textContent = executable;
        document.documentElement.appendChild(script);
      }

      document.documentElement.removeChild(script);
    };
    {
      const executable = ${wrapped};
      injectScriptInMainContext(executable);
    }
  `;
}
export async function executeFunction(tabId, frameId, func, args = []) {
    var _a;
    if ((_a = browser.scripting) === null || _a === void 0 ? void 0 : _a.executeScript) {
        const world = "MAIN";
        const injection = {
            target: { tabId, frameIds: [frameId] },
            world,
            injectImmediately: true,
            func,
            args,
        };
        return await browser.scripting.executeScript(injection);
    }
    const code = getMV2ScriptToInject(func, ...args);
    return await browser.tabs.executeScript(tabId, {
        frameId,
        code,
        matchAboutBlank: true,
        runAt: "document_start",
    });
}
